<template>
  <div class="container">
    <Select
      ref="select"
      v-model="inputValue"
      @update:value="valueSelected"
      :disabled="disabled"
      searchable
      itemsPlacement="bottom-start"
      :matchItemsWidth="false"
      :itemsOffset="20"
      :items="getComponentLookupOptions"
    >
      <template #default="item">
        <span class="item" v-bind:style="itemStyle">{{ item.data.label }}</span>
      </template>
    </Select>
    <div v-if="showInfo" class="search-info">{{ searchInfo }}</div>
  </div>
</template>

<script>
import Select from '@wizer/core/components/select/Select.vue'
import ComponentDataService from '../services/ComponentDataService'

export default {
  name: 'ComponentLookupSelect',
  components: {
    Select,
  },
  props: {
    value: null,
    component: null,
    disabled: {
      type: Boolean,
      default: false,
    },
    // Limits Select dropdown width to half of total window width
    limitWidth: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectValue: null,
      itemsCount: null,
      showInfo: false,
      fetchItems: 10,
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    itemStyle() {
      const offset = this.itemsCount >= 0 && this.itemsCount <= 5 ? 25 : 40
      return {
        minWidth: `${this.$refs.select.$el.clientWidth - offset}px`,
        ...(this.limitWidth && {
          maxWidth: `${(window.innerWidth + this.$refs.select.$el.clientWidth) / 2 - offset}px`,
          margin: '0 5px',
        }),
      }
    },
    searchInfo() {
      if (!this.$refs.select || !this.$refs.select.isOpen) {
        return null
      }
      if (this.itemsCount < 0) {
        return this.$t('vue.common.component.lookup.searching')
      }
      if (this.itemsCount === 0) {
        return this.$t('vue.common.component.lookup.empty')
      }
      if (this.itemsCount > this.fetchItems) {
        return this.$t('vue.common.component.lookup.partial', [
          `${this.fetchItems}`,
          `${this.itemsCount}`,
        ])
      }
      return this.$t('vue.common.component.lookup.full', [`${this.itemsCount}`])
    },
  },
  methods: {
    valueSelected(value) {
      this.$emit('select', value)
    },
    async getComponentLookupOptions(event) {
      return this.fetchComponentLookupOptions(this.component, event)
    },
    async fetchComponentLookupOptions(component, { query }) {
      this.itemsCount = -1
      this.showInfo = true
      const componentData = (
        await ComponentDataService.getComponentLookupOptions(
          component,
          query,
          '0',
          `${this.fetchItems}`,
        )
      ).data
      this.itemsCount = componentData.count
      if (this.itemsCount === 0) {
        // we need an empty item to fix display issues
        return [{ data: { label: null, value: null } }]
      }
      return componentData.options
    },
  },
}
</script>

<style lang="postcss" scoped>
.container {
  @apply relative;
}
.search-info {
  @apply p-1 text-xs text-gray-500 absolute;
  padding-top: 5px;
}
</style>
